import {reqWithToken} from './requestHelper';

function create(url) {
    async function getAll() {
        return (await reqWithToken(url)).data;
    }
    async function insert(insert) {
        return (await reqWithToken(url,{
            method: 'post',
            data: insert
        })).data;
    }

    async function remove(id) {
        return (await reqWithToken(url,{
            method: 'delete',
            params: { id}
        })).data;
    }

    async function update(update) {
        return (await reqWithToken(url,{
            method: 'put',
            data: update
        })).data;
    }

    async function get(id) {
        return (await reqWithToken(`${url}${id}`)).data;
    }


    return {getAll, insert, remove, update, get};
}

export default create;